<template>
    <div>
        <div class="container bg-black rounded" :style="`height: ${timelineHeight}px; border: solid 1px rgb(0,0,0)`">
            <div class="timeline">
                <ul>
                    <li class="timeline-content" v-for="(event, i) in events" v-bind:key="i+1" >
                        <p class="date fs-6">{{event.datetime}}</p>
                        <h1>{{event.total}} Event(s)</h1>
                        <hr class="mt-2" style="color: ; height: 2px;">
                        <div class="input-group flex-nowrap mt-2" v-for="(element, j) in event.elements" v-bind:key="j+1">
                            <button class="btn me-1 fs-6" style="height: 40px; width: 20%;" data-bs-toggle="tooltip" data-bs-placement="top" :title="`Event type: ${element.type}`" @click="viewEvent(event, element)"
                            :class="{'btn-info': element.description.includes('cleared') , 'btn-synapse-danger': !element.description.includes('cleared')  }">
                                <i class="fa-solid fa-xl " :class="{'fa-clock':   element.type == 'latency',
                                                                    'fa-percent': element.type == 'similarity',
                                                                    'fa-code'   : element.type == 'status-code',
                                                                    'fa-triangle-exclamation': element.type == 'critical',
                                                                    'fa-code'   : element.type == 'technical',
                                                                    'fa-check':  element.type == 'clear',
                                                                    'fa-beat':  !element.description.includes('cleared') }"></i>
                            </button>
                            <input class="btn bg-synapse-glass text-white fs-6 fw-light"  type="text" style="width: 80%;" :value="element.description" :title="capitalize(element.description)" readonly>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="bg-black mt-1 rounded p-1">
            <div class="input-group flex-nowrap mt-2">
                <button class="btn me-1 fs-6" style="height: 40px; width: 10%;" data-bs-toggle="tooltip" data-bs-placement="top" title="Click here to view details below."
                :class="{'btn-synapse-dark': !see.status, 'btn-synapse-danger': see.status }">
                    <i class="fa-solid fa-xl" :class="`fa-${see.icon}`"></i>
                </button>
                <input class="btn bg-synapse-glass text-white fs-6 me-1"  type="text" style="height: 40px; width: 40%;" :value="see.name" readonly>
                <input class="btn bg-synapse-glass text-white fs-6 fw-light"  type="text" style="height: 40px; width: 50%;" :value="sev.datetime" :title="capitalize(sev.datetime)" readonly>
            </div>
            <div class="input-group flex-nowrap mt-1">
                <input class="btn bg-synapse-glass text-white fs-6"  type="text" style="width: 100%; height: 45px;" :value="capitalize(see.description)" :title="capitalize(see.description)" readonly>
            </div>
        </div>
    </div>
</template>


<script>

export default {
  name: 'Timeline',
  props:{
    timelineHeight: String,
    events: Array
  },
  data() {
      return {
        appServiceUrl: process.env.VUE_APP_SERVICE_URL,
        appName: process.env.VUE_APP_SERVICE_NAME,
        sev: {datetime: "Datetime"}, // Selected Event
        see: {name: "Event Name", description: "Description", icon: "info", state: "dark"} // Selected Element
      }
  },
  methods: {
    capitalize(_string){
      const lower = _string.toLowerCase()
      return _string.charAt(0).toUpperCase() + lower.slice(1)
    },
    resetVisor(){
        this.sev = {datetime: "Datetime"}
        this.see = {name: "Event Name", description: "Description", icon: "info", state: "dark"}
    },
    viewEvent(_event, _element){
        this.sev = _event
        this.see = _element
    }
  },
  mounted: function(){}
}
</script>

<style scoped>
    @import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@300;500&display=swap");
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html {
  font-family: "Montserrat";
}
.container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  overflow-y: scroll;
}
.timeline {
  width: 90%;
  height: auto;
  margin: auto auto;
  position: relative;
}

.timeline ul {
  list-style: none;
}
.timeline ul li {
  padding: 20px;
  background-color: #000000;
  color: white;
  border-radius: 10px;
  margin-bottom: 20px;
}
.timeline ul li:last-child {
  margin-bottom: 0;
}
.timeline-content h1 {
  font-weight: 500;
  font-size: 25px;
  line-height: 30px;
  margin-bottom: 10px;
}
.timeline-content p {
  font-size: 16px;
  line-height: 30px;
  font-weight: 300;
}
.timeline-content .date {
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 10px;
  letter-spacing: 2px;
}
@media only screen and (min-width: 768px) {
  .timeline:before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 100%;
    background-color: gray;
  }
  .timeline ul li {
    width: 50%;
    position: relative;
    margin-bottom: 50px;
  }
  .timeline ul li:nth-child(odd) {
    float: left;
    clear: right;
    transform: translateX(-30px);
    border-radius: 20px 0px 20px 20px;
  }
  .timeline ul li:nth-child(even) {
    float: right;
    clear: left;
    transform: translateX(30px);
    border-radius: 0px 20px 20px 20px;
  }
  .timeline ul li::before {
    content: "";
    position: absolute;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background-color: rgb(0, 54, 73);
    top: 0px;
  }
  .timeline ul li:nth-child(odd)::before {
    transform: translate(50%, -50%);
    right: -30px;
  }
  .timeline ul li:nth-child(even)::before {
    transform: translate(-50%, -50%);
    left: -30px;
  }
  .timeline-content .date {
    position: absolute;
    top: -35px;
  }
  .timeline ul li:hover::before {
    background-color: rgb(108, 194, 225);
    box-shadow: 0px 0px 25px 0px rgb(249, 249, 249);
  }
}

  /* BTN-Synapse */
    .btn-synapse{
        background-color: rgb(108, 194, 225);
        color: Black;
        box-shadow: 0px 0px 8px 0px rgb(249, 249, 249);
        transition-duration: 0.5s;
    }
    .btn-synapse:hover{
        box-shadow: 0px 0px 25px 0px rgb(249, 249, 249);
        color: White;
    }

    .btn-synapse-dark{
        background-color: rgb(0, 54, 73);
        color: White;
        box-shadow: 0px 0px 8px 0px rgb(0, 81, 125);
        transition-duration: 0.5s;
    }
    .btn-synapse-dark:hover{
        box-shadow: 0px 0px 25px 0px rgb(0, 81, 125);
        color: rgb(52, 143, 186);
    }

    .btn-synapse-danger{
        background-color: rgb(0, 2, 62);
        color: White;
        box-shadow: 0px 0px 8px 0px rgb(33, 35, 93);
        transition-duration: 0.5s;
    }
    .btn-synapse-danger:hover{
        box-shadow: 0px 0px 25px 0px rgb(1, 28, 43);
        color: rgb(255, 0, 0);
    }

    .bg-synapse-glass{
        box-shadow: inset 0 0 2000px rgba(13, 80, 106, 0.447);
    }
    .bg-glass{
        box-shadow: inset 0 0 2000px rgba(255, 255, 255, 0.216);
    }
    .bg-light-glass{
        box-shadow: inset 0 0 1000px rgba(50, 248, 255, 0.108);
    }

</style>